const ConfirmStatus = {
  UNCONFIRMED: {
    value: 0,
    text: '未確認'
  },
  CONFIRMED: {
    value: 1,
    text: '確認済み'
  }
};

export default ConfirmStatus;



// WEBPACK FOOTER //
// ./src/constants/legal_check_confirm/confirm_status.js